// Parse user-typed scheme strings into a numeric array.
// Accepts dashes, commas, slashes, and "/" e.g.:
//   "21-15-9"   → [21, 15, 9]
//   "10,8,6,4,2"→ [10, 8, 6, 4, 2]
//   "95/115/135"→ [95, 115, 135]
// Returns null when there isn't anything meaningful.
export function parseScheme(input) {
  if (input == null || input === "") return null;
  if (Array.isArray(input)) return input.filter((n) => !Number.isNaN(Number(n))).map(Number);
  const parts = String(input)
    .split(/[\s,\/–—-]+/)
    .map((p) => p.trim())
    .filter(Boolean)
    .map(Number)
    .filter((n) => !Number.isNaN(n));
  return parts.length ? parts : null;
}

// Stringify a scheme array → "21-15-9" using "-" as the canonical separator.
export function formatScheme(arr) {
  if (!Array.isArray(arr) || arr.length === 0) return "";
  return arr.map((n) => (Number.isInteger(n) ? n : Number(n).toString())).join("-");
}

// Pull the prescribed value for a given 1-indexed set number from a scheme
// array. Falls back to `defaultValue` when out of range or scheme is empty.
export function valueForSet(scheme, setNumber, defaultValue) {
  if (!Array.isArray(scheme) || scheme.length === 0) return defaultValue ?? null;
  const i = Math.max(1, Number(setNumber) || 1) - 1;
  if (i < scheme.length) return scheme[i];
  // Beyond the prescribed range we hold the last value (most CrossFit ladders
  // are exact — but if a coach asks for 6 sets on a 5-entry scheme we don't
  // want to crash, we just keep the last weight).
  return scheme[scheme.length - 1];
}
